import Radio from './Radio'
import ImageSelect from './ImageSelect'
import BoxSelect from './BoxSelect'
import Slider from './Slider'
import Binary from './Binary'
import Select from './Select'
import Scroller from './Scroller'
import Star from './Star'
import TextResponse from './TextResponse'
import ImageUpload from './ImageUpload'
import HumanMap from './HumanMap'
import MultiQuestion from './MultiQuestion'
import LongTextBubble from './LongTextBubble'
import SignDocument from './SignDocument'
import Date from './Date'
import Unit from './Unit'

export default {
	Radio,
	ImageSelect,
	BoxSelect,
	Slider,
	Binary,
	Select,
	Scroller,
	Star,
	TextResponse,
	ImageUpload,
	HumanMap,
	MultiQuestion,
	LongTextBubble,
	SignDocument,
	Date,
	Unit
}
